import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from '../../app.component';
import * as $ from 'jquery';
import { DatePipe } from '@angular/common';
import { OrderPipe } from 'ngx-order-pipe';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
    selector: 'app-nesids-ongoing-projects',
    templateUrl: './nesids-ongoing-projects.component.html',
    styleUrls: ['./nesids-ongoing-projects.component.scss']
})
/** nesids-ongoing-projects component*/
export class NesidsOngoingProjectsComponent {
    /** nesids-ongoing-projects ctor */
  nesidsOngoingProjects: any='';
  route: any;
    MenuList: any;
    title: any;
  fileUrl: any;
  itemsPerPage: number;
  Search: any;
  paginationPageNumber: number;
  nesidsOngoingProjectsCount: any;
  currentDate: any = new Date();
  modeltitle: any;
  content: any;
  image: any;
  multipleEntry: boolean = false;
  imgUrl: any;
    url: any;
  nesidsSpinner: boolean;
  constructor(private spinner: NgxSpinnerService,private appComponent: AppComponent, private http: HttpClient, private router: Router, private datePipe: DatePipe, private orderpipe: OrderPipe) {
    this.imgUrl = window["orginalImgUrl"];
    this.fileUrl = window["getfile"];
    this.url = window['NESIDSOngoingProjects']
    var str = this.router.url;
    this.route = str.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
  }
  ngOnInit() {
    this.spinner.show();
    this.paginationPageNumber = 1;
    this.itemsPerPage = 10;
    this.getMenuName();
    this.getNESIDSOngoingProjects();
   
  }

  search() {
    this.paginationPageNumber = 1;
  }

  getMenuName() {
    this.http.get(this.appComponent.APIUrl + 'MenuMaster/', {
    }).subscribe((data: any) => {
      this.MenuList = data.menuMasterDTO.filter(x => x.link == this.route);
      this.title = this.MenuList[0].title;
      this.multipleEntry = this.MenuList[0].multipleEntry;
    });
  }
  getNESIDSOngoingProjects() {
    if (this.url != '') {
      this.nesidsSpinner = true;
      this.http.get(this.url, {
      }).subscribe((data: any) => {
        this.nesidsSpinner = false;
        this.nesidsOngoingProjects = data;
        this.nesidsOngoingProjectsCount = this.nesidsOngoingProjects.length;
      });
    }
  }
  itemPerPagePagination(event: any) {
    this.itemsPerPage = event.target.value;
  }
}
